import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@bingads-webui-react/primitive-unthemed';
import { getPreview, getPreviewByType } from './preview-factory';
import { ImageExperienceImage } from '../model/image-experience-image';

const CarouselPreview178x100 = (props) => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel
      className="edit-carousel-container"
      activeIndex={index}
      onSelect={handleSelect}
      controls={false}
    >
      <Carousel.Item>
        {getPreviewByType(
          props.image,
          props.previewTexts,
          props.i18n,
          true,
          'BingSingleImage'
        )}
      </Carousel.Item>
      <Carousel.Item>
        {getPreview(
          props.image,
          props.previewTexts,
          props.i18n
        )}
      </Carousel.Item>
    </Carousel>
  );
};

CarouselPreview178x100.propTypes = {
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
  }).isRequired,
  image: PropTypes.instanceOf(ImageExperienceImage).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
};

export { CarouselPreview178x100 };
